import {
  GET_SERIES,
  GET_SERIES_DETAILS,
  SeriesActionTypes,
  SET_ERROR,
  SET_SERIES,
  SET_SERIES_DETAILS,
  SET_SERIES_SUBMISSION_REPORTS,
  SET_SERIES_TRAINING_REPORTS,
  ADD_REPORT_AS_BEING_GENERATED,
  REMOVE_REPORT_AS_BEING_GENERATED,
  RESET_REPORTS_GENERATED_LIST,
  SET_ACTIVE_SERIES_IDS,
  SET_FUTURE_SERIES_IDS,
  SET_IS_LOADING,
  SET_SUBMISSION_REPORT_REQUEST_IS_LOADING,
  SET_SUBMISSION_REPORT_INDEX,
  SET_SUBMISSION_REPORT_HAS_LOADED,
  SET_SERIES_COMPONENTS_DATES,
} from './types';
import { SeriesData, SeriesDetails, Report, SeriesComponentsDates } from '../../types/Series';

export const setIsLoading = (value: boolean): SeriesActionTypes => ({
  type: SET_IS_LOADING,
  payload: { value },
});

export const setSeriesComponentsDates = (seriesComponents: SeriesComponentsDates): SeriesActionTypes => ({
  type: SET_SERIES_COMPONENTS_DATES,
  payload: { seriesComponents },
});

export const getSeries = (): SeriesActionTypes => ({
  type: GET_SERIES,
});

export const setSeries = (seriesData: SeriesData): SeriesActionTypes => ({
  type: SET_SERIES,
  payload: { seriesData },
});

export const getSeriesDetails = (): SeriesActionTypes => ({
  type: GET_SERIES_DETAILS,
});

export const setSeriesDetails = (seriesDetails: SeriesDetails | undefined): SeriesActionTypes => ({
  type: SET_SERIES_DETAILS,
  payload: { seriesDetails },
});

export const setError = (): SeriesActionTypes => ({
  type: SET_ERROR,
});

export const setSeriesSubmissionReports = (submissionReports: Report[]): SeriesActionTypes => ({
  type: SET_SERIES_SUBMISSION_REPORTS,
  payload: { submissionReports },
});

export const setSeriesTrainingReports = (trainingReports: Report[]): SeriesActionTypes => ({
  type: SET_SERIES_TRAINING_REPORTS,
  payload: { trainingReports },
});

export const addReportAsBeingGenerated = (index: number): SeriesActionTypes => ({
  type: ADD_REPORT_AS_BEING_GENERATED,
  payload: { index },
});

export const removeReportAsBeingGenerated = (index: number): SeriesActionTypes => ({
  type: REMOVE_REPORT_AS_BEING_GENERATED,
  payload: { index },
});

export const resetReportsGeneratedList = (): SeriesActionTypes => ({
  type: RESET_REPORTS_GENERATED_LIST,
});

export const setActiveSeriesIds = (ids: number[]): SeriesActionTypes => ({
  type: SET_ACTIVE_SERIES_IDS,
  payload: { ids },
});

export const setFutureSeriesIds = (ids: number[]): SeriesActionTypes => ({
  type: SET_FUTURE_SERIES_IDS,
  payload: { ids },
});

export const setSubmissionReportIsLoading = (isLoading: boolean): SeriesActionTypes => ({
  type: SET_SUBMISSION_REPORT_REQUEST_IS_LOADING,
  payload: { isLoading },
});

export const setSubmissionReportIndex = (index?: number): SeriesActionTypes => ({
  type: SET_SUBMISSION_REPORT_INDEX,
  payload: { index },
});

export const setSubmissionReportHasLoaded = (hasLoaded: boolean): SeriesActionTypes => ({
  type: SET_SUBMISSION_REPORT_HAS_LOADED,
  payload: { hasLoaded },
});

export default {
  getSeries,
  setSeries,
  setError,
  getSeriesDetails,
  setSeriesDetails,
  setSeriesSubmissionReports,
  setSeriesTrainingReports,
  addReportAsBeingGenerated,
  removeReportAsBeingGenerated,
  resetReportsGeneratedList,
  setActiveSeriesIds,
  setFutureSeriesIds,
  setIsLoading,
  setSubmissionReportIsLoading,
  setSubmissionReportIndex,
  setSubmissionReportHasLoaded,
  setSeriesComponentsDates,
};
